module.exports = JSON.parse('{"Series is tracked":"السلسلة متتبعة","Series is untracked":"السلسلة غير متتبعة","Viewport":"منفذ العرض"}')